import Http from 'services/http2';
import BaseService from 'services/base';
import CompanyService from './company2';

const ESignService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},

    /**
     * 列表页获取未签章数量
     *
     * @param companyCode
     * @param signOrderType 1：采购单,2：供应商合同3：询价招标,4：对账单;
     * @returns
     */
    async getCount(
      companyCode: string,
      signOrderType: number,
      isPurchase: boolean = true
    ) {
      let rs: any = {};
      if (!companyCode) {
        return rs;
      }
      const postbody = {
        companyCode,
        erpOrgCode: '',
        signOrderType,
        apiPath: isPurchase
          ? '/esign/query/bookmark/count'
          : '/esign/query/vendor/bookmark/count'
      };
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          rs = response.data;
        }
      });
      return rs;
    },

    /**
     * 当前单据是否开启电子签章
     *
     * 采访方检查平台参数中是否开启，单据类型是否匹配，并且检查供应商档案中是否开启。
     * 供应商检查客户平台参数是否开启，单据类型是否匹配，并且检查客户档案中是否开启。
     *
     * @param companyCode  本方企业编码
     * @param xkUniqueCode 对方唯一编码
     * @param type         单据类型 1.采购单 2.供应商合同 3.询价招标 4.对账单
     * @param isPurchase   是否采购方
     * @param customerCode 客户企业编码
     *
     * @return {isOpen 是否开启, isAuto 是否自动, isContractSignName 合同是否需要设置签署人}
     */
    async checkOpenFlag(
      companyCode: string,
      xkUniqueCode: string,
      type: string,
      isPurchase: boolean = true,
      customerCode: string = ''
    ) {
      let isOpen: boolean = false;
      let isAuto: boolean = false;
      let isAlowMobile: boolean = false;
      let isContractSignName: boolean = false;
      let code = isPurchase ? companyCode : customerCode;
      await this.getCompanyParams(code).then(rs => {
        isOpen = rs['Signatures_Opened_Flag'] === '1';
        isAuto = rs['Signatures_Auto_Flag'] === '1';
        isAlowMobile = rs['Signatures_Mobile_Order_Pre_Confirm_Flag'] === '1';
        isContractSignName = rs['Signatures_Set_Signatory_Name'] === '1';
        if (isOpen) {
          isOpen = rs['Signatures_Order_Type'].split(';').includes(type);
        }
      });
      if (isOpen) {
        if (isPurchase) {
          await CompanyService.getVendorDetail(companyCode, xkUniqueCode).then(
            rs => {
              isOpen = rs.esignFlag === 1;
            }
          );
        } else {
          await CompanyService.getCustomerDetail(
            companyCode,
            xkUniqueCode
          ).then(rs => {
            isOpen = rs.esignFlag === 1;
          });
        }
      }
      return { isOpen, isAuto, isAlowMobile, isContractSignName };
    },

    /**
     * 获取电子签章企业参数 (关闭缓存)
     *
     * @param companyCode 企业编码
     *
     * @return companyParams
     *   Signatures_Opened_Flag                   是否启用电子签章 '0'|'1'
     *   Signatures_Order_Type                    启用的单据类型（多选） 1.采购单 2.供应商合同 3.询价招标 4.对账单, 例如：'1;2;4'
     *   Signatures_Payment_Type                  付款方式(单选) 1.采购方付费, 2.供应商付费, 3.双方分摊付费, 4.发起方付费, 5.接收方付费
     *   Signatures_Auto_Flag                     是否自动签章 '0'|'1'
     *   Signatures_Mobile_Order_Pre_Confirm_Flag 允许移动端先行确认单据 '0'|'1'，如果不允许，确认单据时提示 "客户已开启自动签章，请到PC端订单详情确认"
     *   Signatures_Set_Signatory_Name            合同电子签章是否需要设置签署人
     */
    async getCompanyParams(companyCode: string) {
      let companyParams = {};
      await CompanyService.getCompanyParamsByCodes(
        companyCode,
        [
          'Signatures_Opened_Flag',
          'Signatures_Order_Type',
          'Signatures_Payment_Type',
          'Signatures_Auto_Flag',
          'Signatures_Mobile_Order_Pre_Confirm_Flag',
          'Signatures_Set_Signatory_Name'
        ],
        false
      ).then(res => {
        if (Array.isArray(res)) {
          res.forEach(item => {
            companyParams[item.paramCode] = item.paramValue;
          });
        }
      });
      return companyParams;
    }
  },
  BaseService
);

export default ESignService;
